// extracted by mini-css-extract-plugin
export var Heading = "footer-module--Heading--6329e";
export var copyright = "footer-module--copyright--e7e12";
export var menuGroup = "footer-module--menuGroup--1b37f";
export var minimal = "footer-module--minimal--9b48c";
export var nav = "footer-module--nav--88e39";
export var siteFooter = "footer-module--siteFooter--ad5dd";
export var socials = "footer-module--socials--a748e";
export var subMenu = "footer-module--subMenu--154f2";